import React from 'react';
import { Box, Container } from '@mui/material';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import Header from '../../components/header';
import { BackButton } from '../../components/backButton';
import { useShowNotificationPrompt } from '../../components/hooks/useShowNotificationPrompt';
import { PullToRefreshReload } from '../../components/pullToRefreshReload';

export interface LayoutProps {
  children: React.ReactNode;
}

function Layout({ children }: LayoutProps) {
  const { open, loading, handleEnable, handleSkip } = useShowNotificationPrompt();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <PullToRefreshReload />
      <Header />

      <Box component="main" sx={{ flex: 1 }}>
        <Container sx={{ mt: 10, py: 5 }}>
          <BackButton />
          {children}
        </Container>
      </Box>
      <Dialog
        open={open}
        onClose={handleSkip}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            p: 0.5,
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: 700, pb: 1 }}>Включить уведомления?</DialogTitle>

        <DialogContent sx={{ pt: 0 }}>
          <DialogContentText sx={{ color: 'text.secondary', lineHeight: 1.5 }}>
            Например, мы можем раз в день присылать уведомление:{' '}
            <b>“Не забудьте внести доходы и расходы”</b>.
            <br />
            Это можно отключить в любой момент в настройках.
          </DialogContentText>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2, pt: 0, gap: 1 }}>
          <Button
            onClick={handleSkip}
            variant="text"
            color="inherit"
            sx={{ textTransform: 'none' }}
            disabled={loading}
          >
            Не сейчас
          </Button>

          <Button
            onClick={handleEnable}
            variant="contained"
            disableElevation
            sx={{
              textTransform: 'none',
              borderRadius: 2,
              px: 2.5,
              py: 1,
              fontWeight: 700,
            }}
            disabled={loading}
          >
            {loading ? 'Включаем…' : 'Да, включить'}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default Layout;
